export enum AMComplexFilterBanTestId {
  FILTER_BANK = 'am-complex-filter-bank',
  CLEAR_BUTTON_BOX = 'am-complex-filter-clear-button-box',
}
